import { render, staticRenderFns } from "./PageFunArenaLanding.vue?vue&type=template&id=dc07587c&scoped=true&"
import script from "./PageFunArenaLanding.vue?vue&type=script&lang=js&"
export * from "./PageFunArenaLanding.vue?vue&type=script&lang=js&"
import style0 from "./PageFunArenaLanding.vue?vue&type=style&index=0&id=dc07587c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc07587c",
  null
  
)

export default component.exports